// global import
import 'babel-polyfill';
import $ from 'jquery';
import 'slick-carousel';
// module import
import Accordion from './modules/accordion';
import EmbeddedVideo from './modules/embeddedVideo';
import ScrollTo from './modules/scrollto';
import StickyInfobox from './modules/stickyContactInfobox';
import StickyNav from './modules/stickyNav';
import LoginLayer from './modules/loginLayer';

$('html')
    .removeClass('no-js')
    .addClass('js');

new ScrollTo(document);
new Accordion('.accordion');
new StickyNav('.mainnav');
new EmbeddedVideo('.video');
new StickyInfobox('.sticky-sidebar');
new LoginLayer('.header');

/**
 * Slick
 */

$('.cmp-01-stage__slider-slick')
    .on('init', function(slick){
        $('.cmp-01-stage__slide').css('height', 'auto');
        $('.cmp-01-stage__slide').height(slick.target.offsetHeight);

        $(window).resize(function(){
            $('.cmp-01-stage__slide').css('height', 'auto');
            $('.cmp-01-stage__slide').height(slick.target.offsetHeight);
        });
    })
    .slick({
        infinite: true,
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000
    });

/**
 *
 * @type {number}
 */

let navHeight = 0,
    winWidth = $(window).width(),
    elId = '';

if (winWidth > 768) {
    navHeight = $('.mainnav').outerHeight();
}

/**
 * Recalculating navheight on resize
 */

$(window).resize(function() {
    winWidth = $(window).width();

    if (winWidth > 760) {
        navHeight = $('.mainnav').outerHeight();
    } else {
        navHeight = 0;
    }
});

/**
 * scrollToSection Function
 */

$.fn.extend({
    scrollToSection: function() {
        $(this).click(function(e) {
            elId = $(this).attr('href');
            $('html, body').animate({ scrollTop: $(elId).offset().top - navHeight }, 1000);
            e.preventDefault();
        });

    }
});

/**
 * 1. Fixed Navigation
 * 2. Bubble Teaser
 * 3. Stage Button
 *
 * They all have the ScrollTo
 * Functionality
 */

$('.mainnav__list-link').scrollToSection();
$('.scroll__link').scrollToSection();
$('.stage__scrollTo').click(function(e) {
    let elementId = $(this).attr('href');

    $('html, body').animate({ scrollTop: $(elementId).offset().top }, 500);
    e.preventDefault();
});



// WEBPACK FOOTER //
// ./js/geno.js